import { fetchFilenameConflicts } from 'reducers/Creatives';
import { getFilenameExtension } from 'utils/common';

export function asyncValidateMultipleRename(values, dispatch, props) {
	/*
        Values are stored in `filenames[n]`, where `n` is a number.

        The original names are guaranteed unique, but they can't be used as field names,
        because they can contain `.` characters, which confuses redux-form into thinking it
        should be a nested structure.

        Sync validation provides that each field has a unique newName value, so we don't have
        to worry here about more than one field needing to be marked invalid for each conflict
        we get back from the `conflicts` endpoint.
    */

	let { filenames } = values;
	let { libraryId } = props;

	let filenameEntries = Object.entries(filenames);
	let nameList = filenameEntries.map(([, filename]) => filename.newName);

	return dispatch(fetchFilenameConflicts(libraryId, nameList))
		.then((conflicts) => {
			if(conflicts.length){
				let filenameErrors = conflicts.reduce((prev, conflict) => {
					let { filename } = conflict;
					let matchingEntry = filenameEntries.find(([, value]) => value.newName === filename);
					let [key] = matchingEntry;
					prev[key] = "File name already exists in creative library"; /*
                        When this error is displayed in the error banner, it's presented with the
                        field's label, which is the original filename, so we specify "File name",
                        instead of the usual message to clarify.
                    */

					return prev;
				}, {});

				throw {
					filenames: filenameErrors,
				};
			}
		})
		.catch((error) => {
			throw {
				_error: error?.description,
				filenames: error?.filenames,
			};
		});
}

export function asyncValidateSingleRename(values, dispatch, props) {
	let { newName } = values;
	let { libraryId } = props;

	return dispatch(fetchFilenameConflicts(libraryId, [newName]))
		.then((conflicts) => {
			if(conflicts.length){
				throw {
					newName: "Name already exists in creative library",
				};
			}
		})
		.catch((error) => {
			throw {
				newName: error.newName || error.description,
			};
		});
}

export function baseFilenameRequired(value, allValues, props){
	/*
		The filename is normalized to reattach the extension to the value in the input,
		so we can't just use `requiredNotNull`, because when the input is empty, its value
		will be something like ".mp4".
	*/
	let extension = `.${getFilenameExtension(props.filename)}`;
	if(!value || value.trim() === extension){
		return "Field is required";
	}
}

export function uniqueFilename(value, allValues, props){
	let { previousNames = [], conflicts = []} = props || {};
	let conflictFilenames = conflicts.map(conflict => conflict.filename);

	if(conflictFilenames.includes(value)){
		/*
			We check for the filename existing in the library asynchronously as well,
			but we know already that these names are conflicted, so we can sync validate
			to rule them out before sending more requests to the server.
		*/
		return "Name already exists in creative library";
	}
	if(previousNames.includes(value)){
		return "Name must be unique";
	}
}

export function uniqueFilenameMultiple(value, allValues, props){
	return uniqueFilename(value.newName, allValues, props);
}
